import { render } from "./AttachmentViewer.vue?vue&type=template&id=6792237c"
import script from "./AttachmentViewer.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AttachmentViewer.vue?vue&type=script&charset=utf-8&lang=js"

import "./AttachmentViewer.vue?vue&type=style&index=0&id=6792237c&lang=scss&scope=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__